// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.locationsBlock__fIkwc {
  width: 100%;
}
@media (max-width: 1200px) {
  .locationsBlock__fIkwc {
    height: 55%;
  }
}

.locationsBlockHead__uzSod {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.locationsBlockTitle__GYRZa {
  color: var(--title-inputs-sections-title);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.locationsTree__eoDXZ {
  height: calc(100% - 30px);
  overflow-y: auto;
}
.locationsTree__eoDXZ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.locationsTree__eoDXZ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.locationsTree__eoDXZ::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.locationsTree__eoDXZ::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.tableBodyRowEmpty__nHHSN {
  width: 100%;
}
.tableBodyRowEmpty__nHHSN tr {
  background: unset;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageLocations/components/LocationBlock/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;AA2EE;EAHF;IAII,WAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAxEF;;AA2EA;EACE,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAxEF;;AA2EA;EACE,yBAAA;EACA,gBAAA;AAxEF;AAFE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAIJ;AADE;EACE,+BAAA;EACA,kBAAA;AAGJ;AAAE;EACE,8BAAA;EACA,kBAAA;AAEJ;AACE;EACE,gBAAA;EACA,kBAAA;AACJ;;AA2DA;EACE,WAAA;AAxDF;AA0DE;EACE,iBAAA;AAxDJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.locationsBlock {\n  width: 100%;\n\n  @media (max-width: 1200px) {\n    height: 55%;\n  }\n}\n\n.locationsBlockHead {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.locationsBlockTitle {\n  color: var(--title-inputs-sections-title);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.locationsTree {\n  height: calc(100% - 30px);\n  overflow-y: auto;\n  @include scrollBar;\n}\n\n.tableBodyRowEmpty {\n  width: 100%;\n\n  tr {\n    background: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"locationsBlock": `locationsBlock__fIkwc`,
	"locationsBlockHead": `locationsBlockHead__uzSod`,
	"locationsBlockTitle": `locationsBlockTitle__GYRZa`,
	"locationsTree": `locationsTree__eoDXZ`,
	"tableBodyRowEmpty": `tableBodyRowEmpty__nHHSN`
};
module.exports = ___CSS_LOADER_EXPORT___;
